/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Check_EmailInputs */

const en_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email to confirm your account!`)
};

const es_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Revisa tu correo para confirmar tu cuenta!`)
};

const fr_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez votre e-mail pour confirmer votre compte !`)
};

const de_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfe deine E-Mail, um dein Konto zu bestätigen!`)
};

const ja_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールを確認してアカウントを承認してください！`)
};

const zh_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请查收邮件以确认您的账号！`)
};

const ar_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحقق من بريدك الإلكتروني لتأكيد حسابك!`)
};

const id_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa email Anda untuk mengonfirmasi akun!`)
};

const it_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla la tua e-mail per confermare l'account!`)
};

const ru_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте почту, чтобы подтвердить аккаунт!`)
};

const pt_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique seu e-mail para confirmar a sua conta!`)
};

const ko_auth_check_email = /** @type {(inputs: Auth_Check_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일을 확인하여 계정을 인증해 주세요!`)
};

/**
* | output |
* | --- |
* | "Check your email to confirm your account!" |
*
* @param {Auth_Check_EmailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_check_email = /** @type {((inputs?: Auth_Check_EmailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Check_EmailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_check_email(inputs)
	if (locale === "es") return es_auth_check_email(inputs)
	if (locale === "fr") return fr_auth_check_email(inputs)
	if (locale === "de") return de_auth_check_email(inputs)
	if (locale === "ja") return ja_auth_check_email(inputs)
	if (locale === "zh") return zh_auth_check_email(inputs)
	if (locale === "ar") return ar_auth_check_email(inputs)
	if (locale === "id") return id_auth_check_email(inputs)
	if (locale === "it") return it_auth_check_email(inputs)
	if (locale === "ru") return ru_auth_check_email(inputs)
	if (locale === "pt") return pt_auth_check_email(inputs)
	return ko_auth_check_email(inputs)
});